// extracted by mini-css-extract-plugin
export default {"form":"Sd","inline":"Td","inputWrapper":"Ud","input":"Vd","withoutLabel":"Wd","error":"Xd","label":"Yd"};